import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const CertificationCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Certificazione ANPR',
    path: '/sportello/certificazione',
  },
];
